/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import fetchHelper from "../services/fetchHelper";
import isString from "lodash/isString";

export const countdown = (duration, cb) => {
  let timer = duration; // duration in seconds
  let minutes;
  let seconds;
  setInterval(function () {
    minutes = parseInt(timer / 60, 10);
    seconds = parseInt(timer % 60, 10);
    minutes = minutes < 10 ? "0" + minutes : minutes;
    seconds = seconds < 10 ? "0" + seconds : seconds;
    cb([minutes, seconds]);
    if (--timer < 0) timer = 0;
  }, 1000);
};

export const cleanSessionAndRedirect = (query = "") => {
  window.localStorage.clear();
  window.location.href = `/auth/login${isString(query) ? "?rb=" + query : ""}`;
};

export const logout = (query = "") => {
  // Kill the token, so we won't be able to use again
  fetchHelper.put("/patientmanagement/logout");
  cleanSessionAndRedirect(query);
};

export const logoutIfNoToken = () => {
  if (!window.localStorage.getItem("genToken")) {
    cleanSessionAndRedirect();
    throw { message: "No token" };
  }
};

export const handleUnauthorizedResponseError = (error = {}) => {
  if (!window.Array.isArray(error?.errors)) {
    return;
  }

  error.errors.find((err) => {
    // 403 = Forbidden - Authorization failed
    if (err.code === 403) {
      cleanSessionAndRedirect();
    }
  });
};

export const passwordPattern = {
  value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{16,}$/,
  message:
    "Password must contain at least: 16 characters, 1 digit, 1 uppercase. No special characters allowed.",
};
